export default __webpack_public_path__ + "static/media/3075.d2973129.jpg";